import { makeStyles, Theme } from '@material-ui/core';

export const useButtonStyles = makeStyles<Theme>((theme) => ({
  button: {
    width: 84,
    height: 48,
    background: '#FFFFFF1A',
    borderRadius: 6,
    color: '#F6F8FA',
    border: 'none',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flex: 1,
    },

    '&:disabled': {
      color: '#F6F8FA',
      background: '#FFFFFF0D',
      opacity: 0.3,
    },
  },
  confirm: {
    background: 'rgba(255, 255, 255, 0.04)',
    color: '#62636D',
  },
  linkIcon: {
    marginLeft: '4px',
    display: 'flex',
    '& svg': {
      color: '#ABABAB',
      width: 16,
      height: 17,
      '&:hover': {
        color: '#eeeeee',
      },
    },
  },
  stx20: {
    color: '#949494',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '20px',
    '& > span': {
      color: '#FFF',
    },
  },
  spanTo: {
    fontSize: '12px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px',
    },
  },
}));
